module.exports = __webpack_public_path__ + "static/scale-model-of-trr-cobb-house-in-athens-georgia-34c83175ad6ac04e35c9f6b7801a3982.png";